import axios from 'axios';
import { refreshToken, validateToken } from 'aws-auth-lib';

let apiServerReachable = true;
const apiHealthListeners = new Set();

const notifyApiHealthListeners = () => {
    apiHealthListeners.forEach((listener) => {
        try {
            listener(apiServerReachable);
        } catch {
            // Ignore listener errors to keep API client stable.
        }
    });
};

const setApiServerReachable = (value) => {
    if (apiServerReachable === value) {
        return;
    }

    apiServerReachable = value;
    notifyApiHealthListeners();
};

export const subscribeApiHealth = (listener) => {
    if (typeof listener !== 'function') {
        return () => {};
    }

    apiHealthListeners.add(listener);
    listener(apiServerReachable);

    return () => {
        apiHealthListeners.delete(listener);
    };
};

export const getApiHealth = () => apiServerReachable;

export const api = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL,
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
    }
});

const updateToken = async (action) => {
    const token = await refreshToken();
    api.defaults.headers['AUTH-TOKEN-AWS'] = token;
    action.headers['AUTH-TOKEN-AWS'] = token;
    return action;
};

api.interceptors.request.use(
    async (config) => {
        if (
            !config.headers['AUTH-TOKEN-AWS'] ||
            !validateToken(config.headers['AUTH-TOKEN-AWS'])
        ) {
            config = await updateToken(config);
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => {
        setApiServerReachable(true);
        return response;
    },
    (error) => {
        const status = error?.response?.status;
        const isServerFailure = typeof status === 'number' && status >= 500;
        const isNetworkFailure = !error?.response;

        if (isServerFailure || isNetworkFailure) {
            setApiServerReachable(false);
        }

        return Promise.reject(error);
    }
);
